import React from "react";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import gold from "../assets/gold.jpg";
import classesImg from "../assets/classes.jpg";
import { ArrowBack } from "@mui/icons-material";
import liz from "../assets/liz.jpg";
import dragon from "../assets/dragon.jpg";
import garg from "../assets/garg.jpg";
import ice from "../assets/ice.jpg";

const Info = ({ themeClass }) => {
  return (
    <div className={`${themeClass} min-h-screen w-screen overflow-y-auto overflow-x-hidden pb-10`}>
      <Navbar />
      <div className="text-center mb-8">
         <h3 className="text-sm text-gray-400 tracking-widest text-shadow">KNOWLEDGE BASE</h3>
      </div>
      
      <div className="flex flex-col items-center gap-8 w-full px-4">
        
        {/* Intro */}
        <div className="rpg-panel w-full md:w-[800px] text-center">
            <h1 className="text-[#fbfaaa] text-xl mb-4 underline decoration-4 underline-offset-4 decoration-blue-600">BECOME RICH & OP</h1>
            <div className="border-4 border-black inline-block">
                <img src={gold} alt="gold" className="max-h-[200px]" />
            </div>
        </div>

        {/* Gold Guide */}
        <div className="rpg-panel w-full md:w-[800px]">
            <h1 className="text-[#fbfaaa] text-lg mb-4 text-center border-b-2 border-gray-700 pb-2">HOW TO GET GOLD</h1>
            <div className="text-gray-300 font-[VT323] text-xl leading-relaxed text-justify px-4">
                Best way to get gold is farming in a <span className="text-white">Dungeon</span>. 
                <br/><br/>
                <ul className="list-disc pl-5 space-y-2">
                    <li><span className="text-red-400">Vampires</span> (Vampire Key)</li>
                    <li><span className="text-purple-400">Drows</span> (Drow Key)</li>
                    <li><span className="text-green-400">Lizards</span> (Lizard Key)</li>
                    <li>High Lvl: Mino 2, Dragons, Demons/Ice</li>
                </ul>
                <br/>
                Alternatives: <span className="text-yellow-400">Flipping Items</span> or Buying Diamonds.
                <br/>
                <div className="mt-4 p-2 bg-[#222] border border-gray-600 text-sm">
                    TIP: Use a Ranged class for farming if low level (100-450).
                </div>
            </div>
        </div>

        {/* Stats Guide */}
        <div className="rpg-panel w-full md:w-[800px]">
             <h1 className="text-[#fbfaaa] text-lg mb-4 text-center border-b-2 border-gray-700 pb-2">CLASS SELECTION</h1>
             <div className="text-gray-300 font-[VT323] text-xl leading-relaxed px-4">
                <p className="mb-4"><span className="text-red-500 font-bold">MELEE:</span> High def (Shield), best for AFK training early. Short range (1 tile).</p>
                <p className="mb-4"><span className="text-green-500 font-bold">DISTANCE:</span> Best gold farmer. Auto-target while running. Expensive (Arrows).</p>
                <p className="mb-4"><span className="text-blue-500 font-bold">MAGIC:</span> Highest PvP damage. Cheapest to train. Low defense (Squishy).</p>
                <div className="flex justify-center mt-4 border-4 border-black">
                    <img src={classesImg} alt="classes" />
                </div>
             </div>
        </div>

        {/* Maps */}
        <div className="rpg-panel w-full md:w-[800px]">
            <h1 className="text-[#fbfaaa] text-lg mb-4 text-center border-b-2 border-gray-700 pb-2">FARMING ROUTES</h1>
            <div className="flex flex-col gap-6 items-center">
                <div className="text-center">
                    <h3 className="text-green-400 mb-2">LIZARDS</h3>
                    <img src={liz} className="border-2 border-white max-w-full" alt="liz"/>
                </div>
                <div className="text-center">
                    <h3 className="text-red-400 mb-2">DRAGONS</h3>
                    <img src={dragon} className="border-2 border-white max-w-full" alt="drag"/>
                </div>
                <div className="text-center">
                    <h3 className="text-blue-200 mb-2">ICE</h3>
                    <img src={ice} className="border-2 border-white max-w-full" alt="ice"/>
                </div>
                <div className="text-center">
                    <h3 className="text-gray-400 mb-2">GARGOYLES</h3>
                    <img src={garg} className="border-2 border-white max-w-full" alt="garg"/>
                </div>
            </div>
        </div>

      </div>

      <Link to={'/'} className="fixed bottom-4 left-4 z-50">
        <div className="rpg-btn" style={{width: '50px', background: '#b91c1c'}}>
            <ArrowBack fontSize="large"/>
        </div>
      </Link>
    </div>
  );
};

export default Info;